var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEdit = function SvgIconEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.988 2.5c-.346 0-.68.136-.925.38L3.552 15.293a1.3 1.3 0 0 0-.385.876l-.66 3.944a1 1 0 0 0-.007.083c0 .347.14.68.386.924s.579.381.926.381a.5.5 0 0 0 .102-.01l3.822-.796c.326-.015.635-.15.868-.38l12.51-12.413a1.3 1.3 0 0 0 0-1.849l-3.2-3.172a1.32 1.32 0 0 0-.926-.38m-.221 1.09a.315.315 0 0 1 .443 0l3.2 3.173a.3.3 0 0 1 0 .428l-1.763 1.75-3.622-3.623zm-2.452 2.432 3.622 3.622L7.9 19.604a.32.32 0 0 1-.222.09.5.5 0 0 0-.101.011l-3.805.793a.3.3 0 0 1-.182-.089.3.3 0 0 1-.088-.182l.658-3.93a1 1 0 0 0 .007-.082c0-.08.031-.156.09-.214z",
    clipRule: "evenodd"
  })));
};
export default SvgIconEdit;